module.exports = __webpack_public_path__ + "static/home-video-f3ebbf4d0adb7fbae931caede8451227.mp4";